import React from 'react'

const renderDisclaimerSegment = (part) => {
  if (!part) return null

  if (part.includes('\\m ')) {
    return part.split('\\m ').map((segment, index) => {
      if (index === 0) {
        return <React.Fragment key={index}>{renderDisclaimerSegment(segment)}</React.Fragment>
      }
      const email = segment.trim()
      return (
        <a key={index} href={`mailto:${email}`}>
          {email}
        </a>
      )
    })
  }

  if (part.startsWith('\\b')) return <b>{part.slice(2)}</b>
  if (part.startsWith('\\i')) return <i>{part.slice(2)}</i>
  return part
}

export const renderDisclaimerText = (disclaimerText) => {
  if (!disclaimerText) return null

  return disclaimerText.split('\n').map((line, lineIndex) => (
    <React.Fragment key={lineIndex}>
      {lineIndex > 0 ? <br /> : null}
      {line.split('|').map((part, partIndex) => (
        <span key={partIndex}>{renderDisclaimerSegment(part)}</span>
      ))}
    </React.Fragment>
  ))
}

export const LayoutDisclaimerAboveSsl = ({ layoutConfig }) => {
  if (!layoutConfig?.disclaimerTextAboveSsl) return null

  return (
    <legend
      className="pre-field"
      style={{ fontSize: 12, paddingTop: 10, paddingBottom: 10, lineHeight: 1.2, fontWeight: 'normal', textAlign: 'justify' }}
    >
      {renderDisclaimerText(layoutConfig.disclaimerTextAboveSsl)}
    </legend>
  )
}
